module.exports = __webpack_public_path__ + "img/BN.e1882e0d.svg";